// import React from 'react';
// import logo from './logo.svg';
// import './App.css';
import { useRoutes } from 'react-router-dom'
import routes from '@/routers'
import Layout from '@/components/layout';
import { useAppDispatch } from './store/hooks';
import { useEffect } from 'react';
import { resetDesign } from './reducer/modeslice';

function App() {
  const routeView = useRoutes(routes)
  const dispatch = useAppDispatch()
  useEffect(()=>{
    dispatch(resetDesign())
  },[])
  return (
    <Layout>
      {routeView}
    </Layout>
  );
}

export default App;
